module.exports = __webpack_public_path__ + "static/babboe-curve-mountain-5f868bb72fd5279e973a332ab99b01a1.jpg";